import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as enums from '../enums/smarthub-enums';

@Pipe({name: 'enum'})
export class EnumTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value, args: string): any {
    if (args) {
      const enumClass = enums[args];
      if (enumClass) {
        const key = `ENUMS.${_.snakeCase(args)}.${_.snakeCase(enumClass[value])}`;
        return this.translateService.instant(_.toUpper(key), args);
      } else {
        console.warn(`[${args}] enum type not found for translation`);
        return '[' + args + ']';
      }
    }
  }
}
